import { useEffect } from 'react';
import { useControl } from 'react-map-gl/mapbox';
import type { Units } from '../common';

interface ScaleProps {
  units?: Units;
}

export default function Scale({ units = 'imperial' }: ScaleProps) {
  const { setUnit } = useControl(
    ({ mapLib }) =>
      new mapLib.ScaleControl({
        // only accepts 2 properties: unit and maxWidth
        unit: units,
      }),
    { position: 'bottom' },
  );

  useEffect(() => {
    const scaleEl = document.querySelector('.mapboxgl-ctrl.mapboxgl-ctrl-scale');
    if (scaleEl) {
      scaleEl.setAttribute(
        'style',
        'position: absolute; margin-left: 6.4rem; bottom: 0.55rem; color: #6E7376; border-color: #6E7376; box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);',
      );
      scaleEl.setAttribute('data-testid', 'map-scale');
    }

    document.querySelectorAll('.mapboxgl-ctrl-bottom-left, .mapboxgl-ctrl-bottom-right').forEach((element) => {
      element.setAttribute('style', 'z-index: auto;');
    });
  }, []);

  useEffect(() => {
    setUnit(units);
  }, [units, setUnit]);

  return null;
}
